<template>
    <div class="center">
        <h1>Denna sida verkar ej finnas🤔</h1>
        <v-btn to="/dashboard" color="primary">Jag är vilse, ta mig hem</v-btn>
    </div>
</template>

<script>
export default {
    name: 'NotFound'
}
</script>

<style>
.center {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
</style>